export const cardVaultAppVersion = '0.57'

export type CardVaultPlatform = 'android' | 'windows' | 'web'

export type CardVaultClientMetadata = {
  clientPlatform: CardVaultPlatform
  clientVersion: string
}

export function getCardVaultClientMetadata(): CardVaultClientMetadata {
  if (typeof window !== 'undefined' && window.CardVaultAndroid) {
    return {
      clientPlatform: 'android',
      clientVersion: cardVaultAppVersion,
    }
  }

  if (typeof window !== 'undefined' && window.cardVaultDesktop) {
    return {
      clientPlatform: 'windows',
      clientVersion: window.cardVaultDesktop.version || cardVaultAppVersion,
    }
  }

  return {
    clientPlatform: 'web',
    clientVersion: cardVaultAppVersion,
  }
}
